import { ShopifyCartResponse } from "@/types/frontend";
import axios, { AxiosInstance } from "axios";

const api: AxiosInstance = axios.create();

class StoreFrontApi {
    async getCart(): Promise<ShopifyCartResponse> {
        const res = await api.get<ShopifyCartResponse>("/cart.js");
        return res.data;
    }
    async updateCart(): Promise<ShopifyCartResponse> {
        const res = await api.get<ShopifyCartResponse>("/cart.js");
        return res.data;
    }
}

export const storeFrontApi = new StoreFrontApi();
